@use '../../../../../scss/settings/colors.scss';

.container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
  .buttonViewContent{
    display: flex;
    justify-content: flex-end;
  }
}

.propertiesContainer {
  background-color: colors.$base-white;
  padding-right: 8px;
  padding-bottom: 4px;
  border-radius: 0;
  width: 100%;
}

.section {
  width: 100%;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 44px;
  padding-right: 8px;
}

.sectionTitle {
  font-family: 'SemiBold Inter', sans-serif !important;
  color: colors.$dark-blue;
  font-size: 16px;
  margin-bottom: 16px;
}

.propertyItem {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }


}

.propertyValue {
  background-color: colors.$base-white;
  border: 1px solid colors.$base-white;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  justify-items: flex-start;
  min-height: 48px;
  
  .MuiOutlinedInput-root {
    background-color: colors.$base-white;
    font-family: 'Regular Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    &.Mui-focused fieldset {
      border-color: colors.$brand-purple;
    }
  }
}

.MuiGrid-container {
  row-gap: 24px;
}

.MuiGrid-item {
  padding-top: 0 !important;
}



.versionTable {
  width: 100%;
  margin-top: -10px;
  .versionTableHeader {
    color: colors.$gray-variant-19;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid colors.$gray-variant-4;
    padding: 16px 16px 16px 0;
  }
  
  .versionTableRow {
    td {
      border-bottom: 1px solid colors.$gray-variant-4;
      padding: 16px 16px 16px 0;
      color: colors.$dark-blue;
      font-size: 14px;
    }
    
    &:last-child td {
      border-bottom: none;
    }
  }
}

.viewContentButton {
  background-color: colors.$purple-light-4 !important;
  color: colors.$base-black !important;
  text-transform: none !important;
  font-family: 'Light Inter',sans serif !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  letter-spacing: -0.072px !important;
  border-radius: 8px !important;
  &:hover {
    background-color: colors.$purple-light-2 !important;
  }
}


.editButton {
  &.activeEdit {
    color: colors.$brand-purple;
    background-color: colors.$purple-light-4;
  }
}

.inputs_container {
  display: flex;
  gap: 2%;
  justify-content: space-between;
  flex-wrap: wrap;

  .propertyItem {
    width: 49%;
  }
}

.date_picker {
  min-width: inherit !important;
  width: 100%;
}

.control_attached {
  position: relative;
  z-index: 1;
  width: 116px;
  margin-right: -14px;
  background-color: colors.$base-white;
}